import { render, staticRenderFns } from "./PlanejamentoAcaoFormApuracao.vue?vue&type=template&id=45ccaf6e"
import script from "./PlanejamentoAcaoFormApuracao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormApuracao.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoFormApuracao.vue?vue&type=style&index=0&id=45ccaf6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports